import {
  SET_TRIP_DURATION,
  CLEAR_TRIP_DURATION,
} from '../helpers/constants/actionsConstants';

import type { SetTripDurationAction, ClearTripDurationAction } from './types';
import type { TripDuration } from '../selectors/types';

export const setTripDuration = (
  tripDuration: TripDuration,
): SetTripDurationAction => ({
  type: SET_TRIP_DURATION,
  payload: {
    tripDuration,
  },
});

export const clearTripDuration = (): ClearTripDurationAction => ({
  type: CLEAR_TRIP_DURATION,
});
